export * from "./terrainMaterial.js";
//# sourceMappingURL=index.js.map